module.exports = __webpack_public_path__ + "static/img/solutions5.be4e738c.png";